import { gql } from 'graphql-request';
import {
  LatestTestExecutionPaginationWindow,
  TestExecutionFieldFilterOptions,
} from '@elementary/common-ui/services/gql/types';
import type { ApiTestResultsTableData } from '@elementary/common-ui/components';

export const getTestResultsTableDataQuery = gql`
  query TestResultsTableDataPaged(
    $testIds: [String!]
    $assetIds: [String!]
    $daysBack: Int
    $testExecutionFilters: [Filter!]
    $sort: TestExecutionFieldPaginationSort
    $cursor: String
    $limit: Int!
    $search: String
  ) {
    latestTestExecutionsPaged(
      filters: {
        assetIds: $assetIds
        testIds: $testIds
        daysBack: $daysBack
        search: $search
      }
      testExecutionFilters: $testExecutionFilters
      sort: $sort
      cursor: $cursor
      limit: $limit
    ) {
      items {
        ...LatestTestExecutionFragment
      }
      pageInfo {
        hasNextPage
        nextCursor
      }
    }
  }

  fragment LatestTestExecutionFragment on LatestTestExecution {
    test {
      tableAsset {
        dbName
        schemaName
        tableName
        lastDataModificationTime
        materialization
        tags
        owners
        isCritical
        subscribers
        path
        name
      }
      id
      name
      type
      sourceType
      tags
      owners
      description
    }
    execution {
      subType
      subTestUniqueId
      status
      executionTimestamp
      columnName
      qualityDimension
      failedRows: failures
    }
  }
`;

export const getTestResultsFilterOptionsQuery = gql`
  query TestResultsFilterOptions(
    $testIds: [String!]
    $assetIds: [String!]
    $daysBack: Int
    $search: String
    $testExecutionFilters: [Filter!]
  ) {
    latestTestExecutionsFilterOptions(
      filters: {
        assetIds: $assetIds
        testIds: $testIds
        daysBack: $daysBack
        search: $search
      }
      testExecutionFilters: $testExecutionFilters
    ) {
      field
      options {
        value
        count
      }
    }
  }
`;

export type ApiTestResultsTableDataPagedResponse = {
  latestTestExecutionsPaged: {
    items: ApiTestResultsTableData[];
    pageInfo: LatestTestExecutionPaginationWindow['pageInfo'];
  };
};

export type ApiTestResultsFilterOptionsResponse = {
  latestTestExecutionsFilterOptions: TestExecutionFieldFilterOptions[];
};
